import { Component, Input, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
  AbstractControl
} from '@angular/forms';
import { Entry } from 'contentful';

import { AuthService } from '../../services/auth/auth.service';
import { LocalizationService } from '../../services/localization/localization.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {
  @Input() public globalContent: Entry<any>;
  @Input() public content: Entry<any>;

  public form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });
  public success: boolean;
  public loading: boolean;
  public error: any;

  constructor(
    private authService: AuthService,
    private localizationService: LocalizationService
  ) {}

  ngOnInit() {}

  get email() {
    return this.form.get('email');
  }

  hasError(formControl: AbstractControl, validator: string) {
    return (
      formControl.touched &&
      formControl.dirty &&
      formControl.hasError(validator)
    );
  }

  resetPassword() {
    if (this.form.valid) {
      this.loading = true;

      this.authService
        .resetPassword(
          this.form.value,
          this.localizationService.locale.getValue()
        )
        .then(() => {
          this.success = true;
        })
        .catch(error => {
          if (error.code === 'auth/user-not-found') {
            this.success = true;
          } else {
            console.error(error);
            this.error = error;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      this.error = 'Invalid fields.';
    }
  }
}
